import React from 'react';
import RouteIfRights from 'pages/router/RouteIfRights';
import InventoryHistoryIframe from './InventoryHistoryIframe';

const paths = {
  inventoryHistory: '/reports/inventory/history',
};

export default [
  <RouteIfRights
    exact
    path={paths.inventoryHistory}
    key={paths.inventoryHistory}
    component={InventoryHistoryIframe}
    rights={['reports']}
  />,
];

export { paths };
